import { FC, useEffect, useState } from "react";
import CreditCardForm from "../../../components/common/CreditCardForm";
import { infoSVG } from "../../../assets/SVGs/SVGs";
import ServicesSideBar from "../../../components/Booking-clientSide/appointment/ServicesSideBar";
import { useDispatch, useSelector } from "react-redux";
import { selectedService } from "../../../types/service";
import { Button, message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { clientCreateAppointment } from "../../../network/clientSide";
import { clearCart } from "../../../services/store/slices/cart";
import { useNavigate } from "react-router-dom";
import { selectedPackages } from "../../../types/package";
import { useIntl } from "react-intl";

interface CheckoutAppointmentProps {}

const CheckoutAppointment: FC<CheckoutAppointmentProps> = ({}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: "",
    name: "",
    cvv: "",
    expiry: "",
  });
  const { services, packages, date, start_time, client, location } =
    useSelector(
      (state: {
        cart: {
          services: {
            services: selectedService[];
            packages: selectedPackages[];
            date: Date | null;
            start_time: string | null;
          };
          client: {
            phoneNumber: string | null;
            token: string | null;
            promoCode: {
              id: number;
              code: string;
              value: string;
              value_type: "percentage" | "price";
            } | null;
          };
          location: { id: number | null };
        };
      }) => {
        return {
          services: state.cart.services.services,
          packages: state.cart.services.packages,
          date: state.cart.services.date,
          start_time: state.cart.services.start_time,
          client: state.cart.client,
          location: state.cart.location,
        };
      }
    );
  const { mutate, isLoading } = useMutation(
    (data: any) => clientCreateAppointment(location?.id, client?.token, data),
    {
      onSuccess: (res: any) => {
        console.log(res);

        if (res?.code !== "ERR_BAD_REQUEST") {
          message.success(intl.formatMessage({ id: "bookingSuccess" }));
          const url = window.location.href.split("/pick-date");
          console.log(url);
          navigate(-4);
          dispatch(clearCart());
        } else {
          message.error(
            res?.response?.data?.message ||
              intl.formatMessage({ id: "somethingWentWrong" })
          );
        }
      },
      onError: (err: any) => {
        message.error(
          err?.response?.data?.message ||
            intl.formatMessage({ id: "somethingWentWrong" })
        );
      },
    }
  );
  const createAppointmentWithCashPayment = () => {
    const appointment: any = {
      // team_member_id: services[0]?.teamMember?.id,
      date: date,
      start_time: start_time?.slice(0, 5),
      is_gift: false,
      payment_method: 4,
      services: services?.map((service) => ({
        pricing_option_id: service?.id,
        team_member_id: service?.teamMember?.id,
      })),
      packages: packages?.map((packageItem) => ({
        package_id: packageItem?.id,
        team_member_id: packageItem?.teamMember?.id,
      })),
    };
    if (client?.promoCode) {
      appointment.promo_code_id = client?.promoCode?.id;
    }
    mutate(appointment);
  };
  if (!client?.token) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 max-h-[100vh] p-1 overflow-y-auto">
      <div className="col-span-1 md:col-span-2 ">
        <div className="shadow p-6 space-y-4 rounded-lg ">
          <div className="space-y-4">
            <h4 className="text-salon-primary text-xl ">
              {intl.formatMessage({ id: "pay" })}
            </h4>
            <p className="text-color-sec-title">
              {intl.formatMessage({ id: "payDesc" })}
            </p>
          </div>

          <div className="my-2">
            <Button
              type="primary"
              htmlType="button"
              onClick={createAppointmentWithCashPayment}
              loading={isLoading}
            >
              {intl.formatMessage({ id: "payWithCash" })}
            </Button>
          </div>
          {/* <CreditCardForm
            paymentDetails={paymentDetails}
            setPaymentDetails={setPaymentDetails}
          /> */}
          <div className="flex justify-center gap-1 items-start">
            <span className="translate-y-0.5">{infoSVG}</span>
            <p>{intl.formatMessage({ id: "invoiceWillBeSent" })}</p>
          </div>
        </div>
      </div>
      <div className="col-span-1  ">
        <ServicesSideBar />
      </div>
    </div>
  );
};

export default CheckoutAppointment;
